import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import './AdminPage.css';

function AdminPage() {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    useEffect(() => {
        if (!currentUser) return;
        const fetchUsers = async () => {
            // [수정] ID 토큰을 먼저 가져옵니다.
            const idToken = await currentUser.getIdToken();
            try {
                const response = await fetch(`${API_URL}/api/admin/users?email=${searchTerm}`,{
                    // [수정] headers에 인증 토큰을 추가합니다.
                    headers: { 
                        'Authorization': `Bearer ${idToken}` 
                    }
                });
                const data = await response.json();
                if (response.ok) {
                    setUsers(data);
                } else {
                    console.error("사용자 목록 로딩 실패:", data.message);
                }
            } catch (error) {
                console.error("API 호출 오류:", error);
            }
        };
        fetchUsers();
    }, [searchTerm, currentUser]);

    const handleViewDetails = (userId) => {
        navigate(`/admin/users/${userId}`);
    };

    return (
        <div className="admin-container">
            {/* [수정] 총 사용자 수를 함께 표시합니다. */}
            <h1>사용자 관리 ({users.length}명)</h1>
            <input 
                type="text" 
                placeholder="이메일로 검색..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="admin-search-bar"
            />
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>이름</th>
                        <th>이메일</th>
                        <th>가입일</th>
                        <th>상태</th>
                        <th>작업</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user._id}>
                            <td>{user.userName}</td>
                            <td>{user.email}</td>
                            <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                            <td>
                                {/* [수정] 정지 상태일 경우 만료일 표시 */}
                                {user.status === 'suspended' ? 
                                    `정지됨 (~${new Date(user.suspendedUntil).toLocaleDateString()})` : 
                                    (user.status || 'active')
                                }
                            </td>
                            <td>
                                <button onClick={() => handleViewDetails(user._id)}>상세보기</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AdminPage;